import {getEoru, getEoruHkV} from "@/service/e-grid-service";

export default {
    state() {
        return {
            eoru: [],
            hkv: []
        }
    },
    mutations: {
        setEosrcEoruDict(state, {dictName, data}) {
            state[dictName] = data;
        },
        setEosrcEoruDecitVal(state, {dictName, eobj_id, fieldName, value}) {
            state[dictName].find((row) => row.eobj_id === eobj_id)[fieldName] = value;
        }
    },
    actions: {
        async loadEosrcEoru({commit}, payload) {
            const data = await getEoru(payload);
            if (data && data.result) {
                commit('setEosrcEoruDict', {dictName: 'eoru', data: data.data !== null ? data.data : []})
            }
        },
        async loadEosrcEoruHkV({commit}) {
            const data = await getEoruHkV();
            if (data && data.result) {
                commit('setEosrcEoruDict', {dictName: 'hkv', data: data.data})
            }
        },
        async updEosrcEoruBal({commit}, payload) {
            Object.keys(payload).filter((key) => key !== 'eobj_id').forEach((key) =>
                commit('setEosrcEoruDecitVal', {
                    dictName: 'eoru',
                    eobj_id: payload['eobj_id'],
                    fieldName: key,
                    value: payload[key]
                }));
        }
    }
}